let global = window || {};
export default global.ZJApp;
